import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App/index';
import { Provider } from 'react-redux';
import store from './store';


//import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === "production") {
  console.log = function () {};
} else {
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals(console.log);
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);


